export default function getResource(label) {
    const resources = {
        mlActivated: 'ML ACTIVATED'
    };

    return resources[label];
}
